import { render } from "./terms-and-conditions.vue?vue&type=template&id=f290541a"
import script from "./terms-and-conditions.vue?vue&type=script&lang=js"
export * from "./terms-and-conditions.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__